// TODO: translate when implemented other languages
const RouteNames = {
  Welcome: 'Welcome',
  Home: 'Home',
  LegalAssistant: 'LegalAssistant',
  LegalHistory: 'LegalHistory',
  ReviewingHistory: 'ReviewingHistory',
  FranceAuth: 'FranceAuth',
  UserSettings: 'UserSettings',
  Reviewing: 'Reviewing',
  SpainAuth: 'SpainAuth'
};

export default RouteNames;
